import React, { ReactNode } from 'react';

import { List } from 'antd';
import styled from 'styled-components';

import { SPREADSHEET_EXPORT } from '../constants';
import SettingsListItem from '../SettingsListItem';
import { SettingsListItem as SettingsListItemType } from '../types';

const Title = styled.div`
  font-size: 20px;
  font-family: var(--font-bold);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #222;
`;

const Content = styled.div`
  padding: 30px;
`;

const StyledList = styled(List)`
  margin-top: 20px;

  && .ant-list-item:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  && .ant-list-item:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .custom-list-item-meta .ant-list-item-meta-avatar {
    margin-inline-end: 0 !important;
  }

  .custom-list-item-meta .ant-list-item-meta-description {
    font-size: 12px !important;
    line-height: 12px !important;
  }

  .custom-list-item-meta .ant-list-item-meta-title {
    margin-bottom: 0 !important;
  }
`;

const GeneralSettings = () => {
  return (
    <Content>
      <Title>General</Title>
      <StyledList
        bordered
        dataSource={[SPREADSHEET_EXPORT]}
        renderItem={(item: any): ReactNode => <SettingsListItem item={item} />}
      />
    </Content>
  );
};

export default GeneralSettings;
